"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchInputPlaceholder = void 0;
var _useIsMobile = require("./useIsMobile");
var _useTranslations = require("./useTranslations");
const useSearchInputPlaceholder = () => {
  const isMobile = (0, _useIsMobile.useIsMobile)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  return isMobile ? translations.search : translations.searchDesktop;
};
exports.useSearchInputPlaceholder = useSearchInputPlaceholder;
